import React, { useEffect, useState } from 'react'
import { Box, FormControl, IconButton, InputLabel, LinearProgress, MenuItem, Modal, Select, Tab, Tabs, TextField, Typography } from '@mui/material';
import "../trendStyles.scss";
import Grid from "@mui/material/Grid2";
import { UpdateDiagnosticForActivity, updateFieldVariablesValues, updateUpdateDiagnosticForActivity } from 'src/shared/util/updateDataServer';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { loadLocationDetails } from 'src/stateManagement/redux/slices/location/asyncReducers';
import Swal from 'sweetalert2';
import CloseIcon from '@mui/icons-material/Close';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { CustomTabPanel } from 'src/tecnica/pages/dashboard/reports/close_daily';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Filter, FilterDrawer, FilterList } from 'src/shared/modules/filterDrawer';
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import TuneIcon from '@mui/icons-material/Tune';
import DoneIcon from '@mui/icons-material/Done';
import WarningIcon from '@mui/icons-material/Warning';


const status_candidato_list = [
    { id: "Reevaluación", name: "Reevaluación" },
    { id: "Oportunidad de Incremento", name: "Oportunidad de Incremento" },
    { id: "Mantener Condiciones", name: "Mantener Condiciones" }
]

const condicion_fondo_list = [
    { id: "Golpe de Fluido", name: "Golpe de Fluido", method:['BM'] },
    { id: "Inteferencia por Gas", name: "Inteferencia por Gas", method:['BM'] },
    { id: "Pendiente por Determinar", name: "Pendiente por Determinar", method:['BCP','BM'] },
    { id: "Buenas Condiciones", name: "Buenas Condiciones", method:['BCP','BM'] },
    { id: "Golpe de Bomba", name: "Golpe de Bomba", method:['BM'] },
    { id: "Baja Accion de Bombeo", name: "Baja Accion de Bombeo", method:['BCP','BM'] },
    { id: "Fuga en Valvula Viajera", name: "Fuga en Valvula Viajera", method:['BM'] },
    { id: "Fuga en Valvula Fija", name: "Fuga en Valvula Fija", method:['BM'] },
    { id: "Cierre Tardio de Valvula Fija", name: "Cierre Tardio de Valvula Fija", method:['BM'] },
    { id: "Cierra Tardio de Valvula Viajera", name: "Cierra Tardio de Valvula Viajera", method:['BM'] },
    { id: "Flumping", name: "Flumping", method:['BM'] }
];

const taskStates = [
    { id: "pending", name: "Por Analizar" },
    { id: "analyzing", name: "Evaluar Luego" },
    { id: "finished", name: "Analiazada" }
];

const filters: FilterList[] = [
    {
        name: 'Fecha Inicio',
        field: 'fromDate',
        type: 'date',
        action: 'equalAfter',
        buttons: [],
        options: []
    },
    {
        name: 'Fecha Fin',
        field: 'toDate',
        type: 'date',
        action: 'equalBefore',
        buttons: [],
        options: []
    },
    {
        name: 'Analizado',
        field: 'status',
        type: 'groupButton',
        buttons: [
            { id: 0, name: 'Todo', value: "", action: 'dissable' },
            { id: 1, name: 'SI', value: "completed", action: 'equal' },
            { id: 2, name: 'NO', value: "pending", action: 'equal' }
        ],
        options: []
    },
    {
        name: 'Tipo de Actividad',
        field: 'typeOfActivity',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ["Estudio Completo", "Revisión", "Carta Dinagrafica", "Nivel Dinámico", "Carta Leuter", "Nivel Estático"]
    },
    {
        name: 'Condición',
        field: 'condition',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ["Golpe de Fluido", "Inteferencia por Gas", "Pendiente por Determinar", "Buenas Condiciones", "Golpe de Bomba", "Fuga en Valvula Viajera", "Fuga en Valvula Fija", "Cierre Tardio de Valvula Fija", "Cierra Tardio de Valvula Viajera", "Flumping"]
    },
]

export const ModalDiagnostic = ({ open, onClose }: { open: any, onClose: any }) => {

    const [loading, setloading] = useState(false)

    const [value, setValue] = useState(0);
    const [data, setData] = useState<any[]>([]);

    const { id } = useParams();

    const dispatch = useDispatch();

    const paginationModel = { page: 0, pageSize: 10 };

    const { projectId, locationId, fieldActivities, method } = useSelector((state) => state.location);

    const { activeUser } = useSelector((state) => state.main);

    const columns: GridColDef[] = [
        {
            field: "executedDate",
            headerName: "Fecha",
            width: 90,
            type: "date",
            renderCell: (params) => {
                const date = new Date(params.value);
                return date.toLocaleDateString(); // Formats the date without time zone
            }
        },
        { field: "typeOfActivity", headerName: "Actividad", width: 90, },
        { field: "condition", headerName: "Condición", width: 90 },
        {
            field: 'status', headerName: "", type: 'boolean', width: 20, renderCell: (params) => {
                if (params.value === 'finished') {
                    return (
                        <IconButton size="small" color="success">
                            <DoneIcon />
                        </IconButton>
                    )
                } else if (params.value === 'analyzing') {
                    return (
                        <IconButton size="small" color="warning">
                            <WarningIcon />
                        </IconButton>
                    )
                } else {
                    return ""
                }
            }
        },
    ]

    const [activeActivity, setActiveActivity] = useState<any>(undefined)

    const [showListOfActivities, setshowListOfActivities] = useState(false)

    const [activeDiagnostic, setActiveDiagnostic] = useState<UpdateDiagnosticForActivity>()

    const [variablesToUpdate, setVariablesToUpdate] = useState<any>(undefined)

    const [showFilters, setshowFilters] = useState(false)

    const [filteredData, setFilteredData] = useState<Filter[]>([]);

    const [listOfSelectedActivities, setListOfSelectedActivities] = useState<any[]>([])


    useEffect(() => {

        console.log({method})

        if (open) {
            if (fieldActivities?.length > 0) {
                const newData: any[] = []
                for (const act of fieldActivities) {
                    const diagnostic = act.diagnosticVariables
                    const condition = diagnostic?.find((v: any) => v.id === "26fd1f4d-ec8d-11ef-95e3-00505652cca1")?.value || "No Definido"
                    newData.push({
                        ...act,
                        condition: condition,
                        executedDate: new Date(act.executedDate),
                    })
                }
                setData(newData)
            }

        }
    }, [open])

    useEffect(() => {
        if (listOfSelectedActivities.length > 0) {

            const firstActivitySelected = listOfSelectedActivities[0]
            const fieldVariables = firstActivitySelected?.variables

            const previousDiagnostic = firstActivitySelected['diagnosticVariables']

            const diagnostic = previousDiagnostic?.find((v: any) => v.id === "26fd1c80-ec8d-11ef-95e3-00505652cca1")?.value || ""

            const recommendations = previousDiagnostic?.find((v: any) => v.id === "26fd1ece-ec8d-11ef-95e3-00505652cca1")?.value || ""

            const candidateSate = previousDiagnostic?.find((v: any) => v.id === "26fd1f13-ec8d-11ef-95e3-00505652cca1")?.value || ""

            const bottomHoleConditions = previousDiagnostic?.find((v: any) => v.id === "26fd1f4d-ec8d-11ef-95e3-00505652cca1")?.value || ""

            const subBottomHoleConditions = previousDiagnostic?.find((v: any) => v.id === "3e545921-fc61-11ef-a39b-00505652cca1")?.value || ""

            const bottomHoleFillage = previousDiagnostic?.find((v: any) => v.id === "26fd1f8a-ec8d-11ef-95e3-00505652cca1")?.value

            const ept = previousDiagnostic?.find((v: any) => v.id === "bca80cfd-fcdd-11ef-a39b-00505652cca1")?.value

            const theoricalProduction = previousDiagnostic?.find((v: any) => v.id === "3e545b5c-fc61-11ef-a39b-00505652cca1")?.value

            const pumpEfficiency = previousDiagnostic?.find((v: any) => v.id === "81047dd8-05d4-11f0-af91-00505652cca1")?.value

            const adjustProduction = previousDiagnostic?.find((v: any) => v.id === "1a6387e8-05db-11f0-af91-00505652cca1")?.value

            const dplunger = previousDiagnostic?.find((v: any) => v.id === "e47fc3c4-fc6f-11ef-a39b-00505652cca1")?.value

            const originFieldActivityIds = listOfSelectedActivities.map((activity) => activity.fieldActivityId)

            const newActiveDiagnostic: UpdateDiagnosticForActivity = {
                originFieldActivityIds,
                projectId: projectId,
                locationId: locationId,
                diagnostic: diagnostic || '',
                recommendation: recommendations || '',
                candidateSate: candidateSate || '',
                bottomHoleCondition: bottomHoleConditions || '',
                subBottomHoleCondition: subBottomHoleConditions || '',
                bottomHoleFillage,
                requiredUserId: activeUser?.id || '',
                executedAt: new Date(),
                ept,
                theoricalProduction,
                pumpEfficiency,
                adjustProduction,
                mpt: 0,
                dplunger,
                newFieldActivityState: 'finished',
                optimizationActivitiesSelected: [],
            }

            setActiveDiagnostic(newActiveDiagnostic)
            setActiveActivity(firstActivitySelected)
        }else{
            setActiveDiagnostic(undefined)
            setActiveActivity(undefined)
        }
    }, [listOfSelectedActivities])


    const handleResetSearch = () => {
        setFilteredData([]);
        setData([]);
    };

    const validateDiagnostic = () => {
        const fieldsToValidate = [
            { field: 'diagnostic', message: "El campo diagnostico es requerido" },
            { field: 'recommendation', message: "El campo recomendacion es requerido" },
            { field: 'candidateSate', message: "El campo estado candidato es requerido" },
            { field: 'bottomHoleCondition', message: "El campo condicion de fondo es requerido" }]

        const messageErros: string[] = []

        if (!activeDiagnostic) return messageErros

        const diagnosticTovalidate: any = { ...activeDiagnostic }

        fieldsToValidate.forEach((f) => {
            if (!diagnosticTovalidate[f.field] || diagnosticTovalidate[f.field].trim() === "") {
                messageErros.push(f.message)
            }
        }
        )
        return messageErros
    }

    const onSaveDiagnostic = () => {

        if (variablesToUpdate && value === 0) {
            setloading(true)
            updateFieldVariablesValues(variablesToUpdate).then((data) => {
                setloading(false)
                Swal.fire({
                    title: "Guardado!",
                    icon: "success",
                });
                dispatch(loadLocationDetails(id!));
            }
            ).catch((error) => {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                });
                console.log(error)
                setloading(false)
            })
        }


        if (activeDiagnostic && value === 1) {

            const errors = validateDiagnostic()

            if (errors.length > 0) {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                    html: `<p>No se puede proceder debido a los siguientes errores:</p><ul>${errors.map(error => `<li>${error}</li>`).join('')}</ul>`

                });
                return
            }

            setloading(true)
            updateUpdateDiagnosticForActivity(activeDiagnostic).then((data) => {
                setloading(false)
                Swal.fire({
                    title: "Guardado!",
                    icon: "success",
                });
                dispatch(loadLocationDetails(id!));
            }
            ).catch((error) => {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                });
                console.log(error)
                setloading(false)
            })
        }
    }

    const handleClose = () => {
        if (loading) return
        setActiveActivity(undefined)
        setActiveDiagnostic(undefined)
        setListOfSelectedActivities([])
        onClose()
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleOnChangeValue = (value: any, label: any) => {
        const newActiveDiagnostic: any = { ...activeDiagnostic }
        newActiveDiagnostic[label] = value

        if (label === "bottomHoleCondition") {

            let subBottomHoleCondition = ""

            const condicionesDeficiente = ['Fuga en Valvula Viajera', 'Fuga en Valvula Fija', 'Cierre Tardio de Valvula Fija', 'Cierra Tardio de Valvula Viajera', 'Flumping', "Baja Accion de Bombeo"]

            switch (value) {
                case "Golpe de Fluido":
                    if ((activeDiagnostic?.bottomHoleFillage || 0) < 20) {
                        subBottomHoleCondition = "Golpe de Fluido Critico (<20%)"
                    } else if ((activeDiagnostic?.bottomHoleFillage || 0) < 50) {
                        subBottomHoleCondition = "Golpe de Fluido Llenado Medio (20% al 50%)"
                    } else {
                        subBottomHoleCondition = "Golpe de Fluido Buen Llenado (50% al 90%)"
                    }

                    break;
                case "Inteferencia por Gas":
                    if ((activeDiagnostic?.bottomHoleFillage || 0) < 20) {
                        subBottomHoleCondition = "Inteferencia por Gas Critico (<20%)"
                    } else if ((activeDiagnostic?.bottomHoleFillage || 0) < 50) {
                        subBottomHoleCondition = "Inteferencia por Gas Llenado Medio (20% al 50%)"
                    } else {
                        subBottomHoleCondition = "Inteferencia por Gas Buen Llenado (50% al 90%)"
                    }

                    break;

                default:
                    if (condicionesDeficiente.includes(value)) {
                        subBottomHoleCondition = "Deficiente";
                    } else {
                        subBottomHoleCondition = value;
                    }
                    break;

            }

            newActiveDiagnostic["subBottomHoleCondition"] = subBottomHoleCondition
        }

        setActiveDiagnostic(newActiveDiagnostic)
    }

    const handleSelectOptionFilter = (filter: Filter) => {
        const extraFilter = filteredData.filter(f => f.name !== filter.name);
        setFilteredData([...extraFilter, filter]);
    };

    const handleSelectActivity = (params: GridRowSelectionModel) => {

        const activitySelected: any[] = []

        for (const id of params) {
            const card = data.find((act) => act.fieldActivityId === id);
            if (card) {
                activitySelected.push(card)
            }
        }
        setListOfSelectedActivities(activitySelected)
    }

    return (
        <Modal
            open={open}
            onClose={() => handleClose()}
            sx={{
                zIndex: 4,
            }}
        >
            <Box className="modal_diagnostic_from_trends">
                {/* headers */}
                <Box className="modal_header">
                    <IconButton
                        aria-label="delete"
                        size='small'
                        onClick={handleClose}
                    >
                        <CloseIcon color="error" />
                    </IconButton>
                    <Typography className='title' id="modal-modal-title" variant="h6" component="h2">
                        Analizar Nivel
                    </Typography>
                    <IconButton
                        aria-label="delete"
                        size='small'
                        onClick={() => onSaveDiagnostic()}
                    >
                        <SaveOutlinedIcon color="primary" />
                    </IconButton>
                </Box>
                {loading && (
                    <>
                        <Box className="modal_analyst_loading_background" />
                        <Box className="modal__analyst_task_loading">
                            <LinearProgress />
                            Saving....
                        </Box>
                    </>
                )}
                <Box className="modal_body" sx={{
                    display: 'grid',
                    gridTemplateColumns: `${showListOfActivities ? '410px' : '0.04fr'} 1fr`,
                    overflow: 'scroll'
                }}>
                    <Box className="list_activities">
                        {showListOfActivities && (
                            <>
                                {/* Left Table */}
                                < Grid>
                                    <Grid container spacing={1} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <Typography variant="body1" color="primary" sx={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'center' }}>
                                            Lista de Estudios
                                        </Typography>
                                        <Grid>
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                sx={{ mr: 2 }}
                                                onClick={() => setshowFilters(!showFilters)}
                                            >
                                                <TuneIcon />
                                            </IconButton>
                                        </Grid>

                                        <FilterDrawer
                                            showFilters={showFilters}
                                            filters={filters}
                                            filteredData={filteredData}
                                            setshowFilters={setshowFilters}
                                            handleSelectOptionFilter={handleSelectOptionFilter}
                                            resetFilters={handleResetSearch}
                                        />
                                    </Grid>
                                    {/* Table */}
                                    <Grid className="table">
                                        <DataGrid
                                            rows={data}
                                            columns={columns}
                                            initialState={{
                                                pagination: { paginationModel },
                                                
                                            }}
                                            pageSizeOptions={[10, 20, 50, 100]}
                                            checkboxSelection={true}
                                            sx={{
                                                border: 0,
                                                "& .MuiDataGrid-row:hover": {
                                                    cursor: "pointer",
                                                    backgroundColor: "#f5f5f5",
                                                },
                                                "& .MuiDataGrid-columnHeader": {
                                                    backgroundColor: "#316EBC",
                                                    color: "#fff",
                                                    fontWeight: "bold",
                                                },
                                            }}
                                            getRowId={(row) => row.fieldActivityId}
                                            rowSelectionModel={listOfSelectedActivities.map((activity) => activity.fieldActivityId)} 
                                            onRowSelectionModelChange={(params) => handleSelectActivity(params)}
                                        />
                                    </Grid>

                                </Grid>
                            </>
                        )}
                        <Grid className="button_full_height" onClick={() => setshowListOfActivities(!showListOfActivities)}>
                            {showListOfActivities ? (
                                <KeyboardArrowLeftIcon fontSize="large" />
                            ) : (
                                <KeyboardArrowRightIcon fontSize="large" />

                            )}
                        </Grid>
                    </Box>
                    {/* Body */}
                    {activeActivity ? (
                        <Box sx={{ p: 2, gap: 2 }} >
                            {/* Tabs */}
                            <Box
                                sx={{
                                    borderBottom: 1,
                                    borderColor: "divider",
                                }}
                            >
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    scrollButtons="auto"
                                    variant="scrollable"
                                >
                                    <Tab
                                        label="Variables de la actividad"
                                    />
                                    <Tab
                                        label="Agregar Diagnostico"
                                    />
                                </Tabs>
                            </Box>
                            {/* Variables */}
                            <CustomTabPanel value={value} index={0}>
                                <Grid className="list_activities_variables">
                                    <Typography variant="subtitle1" textAlign={"center"}>
                                        {activeActivity?.executedDate?.toLocaleDateString()} - {activeActivity["executedBy"]}
                                    </Typography>
                                    <Grid className="variables-list-section">
                                        {activeActivity?.variables?.map((variable: any, index: number) => {
                                            if (["Comentario", "Cuadrilla", "Ingenieros"].includes(variable.variable)) return null
                                            return (
                                                <Grid key={index}>
                                                    <TextField
                                                        id="variable"
                                                        size="small"
                                                        onChange={(e) => variable?.variableIdToEdit && setVariablesToUpdate({ ...variablesToUpdate, [variable?.variableIdToEdit]: e.target.value })}
                                                        label={variable.variable}
                                                        value={variablesToUpdate?.[variable?.variableIdToEdit] || variable.value}
                                                        fullWidth
                                                        sx={{
                                                            backgroundColor: variable?.variableIdToEdit ? 'white' : '#f5f5f5',
                                                        }}
                                                    />
                                                </Grid>
                                            )
                                        })}
                                    </Grid>
                                        {activeActivity?.variables?.find((variable: any) => variable.variable === "Comentario") && (
                                            <Grid className="comment-section">
                                            <Typography variant="subtitle2" sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>Comentario</Typography>
                                                <Grid className="comment-value">
                                                {activeActivity?.variables?.find((variable: any) => variable.variable === "Comentario")?.value || ""}
                                                </Grid>
                                            </Grid>
                                        )}
                                </Grid>
                            </CustomTabPanel>
                            {/* Actualizar Diagnostico */}
                            <CustomTabPanel value={value} index={1}>
                                < Box className="modal_analyst_body_trends" >
                                    <Grid size={12}>
                                        <TextField
                                            id="variable"
                                            size="small"
                                            label={"Diagnostico"}
                                            value={activeDiagnostic?.diagnostic || ""}
                                            onChange={(e) => handleOnChangeValue(e.target.value, "diagnostic")}
                                            fullWidth
                                            error={!activeDiagnostic?.diagnostic || activeDiagnostic?.diagnostic.trim() === ""}
                                            multiline
                                            rows={5}
                                        />
                                    </Grid>
                                    <Grid size={12}>
                                        <TextField
                                            id="variable"
                                            size="small"
                                            label={"Recomendacion"}
                                            onChange={(e) => handleOnChangeValue(e.target.value, "recommendation")}
                                            value={activeDiagnostic?.recommendation || ""}
                                            error={!activeDiagnostic?.recommendation || activeDiagnostic?.recommendation.trim() === ""}
                                            fullWidth
                                            multiline
                                            rows={5}
                                        />
                                    </Grid>
                                    <Grid className="list_section">
                                        <FormControl>
                                            <InputLabel>Estatus Candidato</InputLabel>
                                            <Select
                                                value={activeDiagnostic?.candidateSate || ""}
                                                label="Estatus Candidato"
                                                onChange={(e) => handleOnChangeValue(e.target.value, "candidateSate")}
                                                error={!activeDiagnostic?.candidateSate || activeDiagnostic?.candidateSate.trim() === ""}
                                            >
                                                {status_candidato_list.map((status) => (
                                                    <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl>
                                            <InputLabel>Condición de Fondo</InputLabel>
                                            <Select
                                                value={activeDiagnostic?.bottomHoleCondition || ""}
                                                label="Condición de Fondo"
                                                onChange={(e) => handleOnChangeValue(e.target.value, "bottomHoleCondition")}
                                                error={!activeDiagnostic?.bottomHoleCondition || activeDiagnostic?.bottomHoleCondition.trim() === ""}
                                            >
                                                {condicion_fondo_list.map((cond) => (
                                                    <MenuItem key={cond.id} value={cond.id} disabled={cond.method && !cond.method.includes(method)} >
                                                        {cond.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl>
                                            <InputLabel>Nuevo Estado tarea</InputLabel>
                                            <Select
                                                value={activeDiagnostic?.newFieldActivityState || ""}
                                                label="Nuevo Estado tarea"
                                                onChange={(e) => handleOnChangeValue(e.target.value, "newFieldActivityState")}
                                                error={!activeDiagnostic?.newFieldActivityState || activeDiagnostic?.newFieldActivityState.trim() === ""}
                                            >
                                                {taskStates.map((task) => (
                                                    <MenuItem key={task.id} value={task.id}>{task.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <Grid className="sub_states_sections">
                                            {/* <Grid className="label">Llenado : </Grid>
                                    <Grid>  {activeDiagnostic?.bottomHoleFillage ? Math.round(activeDiagnostic?.bottomHoleFillage) : 0} % </Grid> */}
                                            <Grid className="label">Sub Condicion : </Grid>
                                            <Grid> {activeDiagnostic?.subBottomHoleCondition || ""}  </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CustomTabPanel>
                        </Box>
                    ) : (
                        <Box className="noselect_activity">
                            <Typography variant="h6" component="h2">
                                Seleccione una o varias actividad para continuar
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Modal >
    )
}
